'use client';

import { PortableText } from '@portabletext/react';
import { cn } from '@/lib/utils';
import Image from '@/helpers/Image';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { CTAButton } from '@/shadcn/ui/button';
import { PageTextOnlyCryptoSchema } from '@/sanity/pages/PageTextOnlyCryptoTemplate';
import CheckList from './CheckList';
import { CARD_BUTTON_CLASS } from './OfferSection';
import { DotTexture } from './textures';

import chapterIcon from '@/public/text-only-crypto/chapter-icon.svg';

/** Figma: desktop 7218:140, mobile 8662:24614. */
export default function ReasonsSection({
  data,
  className,
}: {
  data: PageTextOnlyCryptoSchema;
  className?: string;
}) {
  const bodyText =
    'richtext richtext-start w-full prose-p:font-geist prose-p:font-normal prose-p:text-[2.25rem] prose-p:leading-[1.6] prose-p:text-[#001B14]/[0.74] prose-p:mb-[2.25rem]';

  return (
    <section
      id="chapter-4"
      data-chapter
      className={cn(
        'relative flex justify-center w-full bg-white max-lg:px-[2rem] lg:px-0 max-lg:py-[8rem] lg:py-[12.5rem]',
        className,
      )}
    >
      <div className="relative flex flex-col w-[min(94.5rem,100%)] overflow-clip rounded-[1rem] border border-[#001B14]/10 bg-[#F7F7F7]">
        <DotTexture className="left-[42.244rem] top-[-14.625rem]" />

        <div className="relative flex flex-col gap-[2.25rem] w-full max-lg:px-[2rem] max-lg:py-[3rem] lg:p-[5.25rem]">
          <div className="flex items-center justify-center w-[5.5rem] h-[5.875rem] bg-black/5">
            <Image
              src={chapterIcon}
              alt=""
              className="w-[3.5rem] h-[3.5rem]"
            />
          </div>

          {data?.reasonsTitle && (
            <div
              className="richtext richtext-start w-full
              prose-p:font-geist prose-p:font-medium max-lg:prose-p:text-[3.5rem] lg:prose-p:text-[4rem] prose-p:leading-[1.12] prose-p:text-[#001B14] prose-p:mb-0"
            >
              <PortableText
                value={data.reasonsTitle}
                components={richTextComponent}
              />
            </div>
          )}

          {data?.reasonsText && (
            <div className={bodyText}>
              <PortableText
                value={data.reasonsText}
                components={richTextComponent}
              />
            </div>
          )}

          {data?.reasonsSubhead && (
            <p className="mb-0 font-geist font-medium text-[2.75rem] leading-[1.5] text-[#001B14]">
              {data.reasonsSubhead}
            </p>
          )}

          <CheckList items={data?.reasonsItems} panelClassName="bg-white" />

          {data?.reasonsText2 && (
            <div className={bodyText}>
              <PortableText
                value={data.reasonsText2}
                components={richTextComponent}
              />
            </div>
          )}

          {data?.reasonsCTA && (
            <CTAButton
              data={data.reasonsCTA}
              overrideVariant="default"
              className={CARD_BUTTON_CLASS}
            />
          )}
        </div>
      </div>
    </section>
  );
}
